import React, { useEffect } from "react";
import WOW from "wowjs";
import "./Footer.css";

const Footer = () => {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);
  return (
    <div>
      <footer>
        <div class="container-fluid">
          <div class="col-md-12">
            <p>Copyright &copy; {new Date().getFullYear()} P.J DIESEL </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
